module.exports = __webpack_public_path__ + "static/media/step-indicator-1.f459541f.svg";